import { ref } from 'vue'

const snackbar = ref({
  show: false,
  message: '',
  color: 'success',
  timeout: 3000,
  actions: []
})

export function useSnackbar() {
  const showSuccess = (message, options = {}) => {
    snackbar.value = {
      show: true,
      message,
      color: 'success',
      timeout: options.timeout || 3000,
      actions: options.actions || []
    }
  }

  const showError = (message, options = {}) => {
    snackbar.value = {
      show: true,
      message,
      color: 'error',
      timeout: options.timeout || 5000,
      actions: options.actions || []
    }
  }

  const showCartSuccess = (message) => showSuccess(message, {
    timeout: 8000,
    actions: [{ text: 'Checkout', to: '/checkout' }]
  })

  const showWarning = (message, options = {}) => {
    snackbar.value = {
      show: true,
      message,
      color: 'warning',
      timeout: options.timeout || 4000,
      actions: options.actions || []
    }
  }

  const showInfo = (message, options = {}) => {
    snackbar.value = {
      show: true,
      message,
      color: 'info',
      timeout: options.timeout || 3000,
      actions: options.actions || []
    }
  }

  return {
    snackbar,
    showSuccess,
    showCartSuccess,
    showError,
    showWarning,
    showInfo
  }
}
